import { defineStore } from 'pinia';
import {getBrands} from '../api.js';

export const useBrandsStore = defineStore('brands', {
    state: () => ({
        brands: [],
        loading: false,
        error: null
    }),
    actions: {
        async fetchBrands() {
            this.loading = true;
            this.error = null;
            try {
                const data = await getBrands();
                this.brands = data.data;
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        }
    },
});
